import React from 'react';
import { Container } from 'reactstrap';
import './index.css';
import StepCard from '../../components/StepCard';
import ScenarioCard from '../../components/ScenarioCard';
import dataprepData from '../../data/DataprepGettingStartedData.json';

const DataprepGettingStarted = () => {
  const getIconPath = (iconName) => {
    try {
      return require(`../../assets/icons/${iconName}`);
    } catch (error) {
      console.warn(`Icon not found: ${iconName}`);
      return null;
    }
  };

  return (
    <div className="dataprep-getting-started">
      <div className="dataprep-container">
        {/* Header Section */}
        <div className="header-section">
          <h1 className="main-title">{dataprepData.header.mainTitle}</h1>
          <p className="sub-title">{dataprepData.header.subTitle}</p>
        </div>

        {/* Step Cards Row */}
        <div className="steps-row">
          {dataprepData.stepCards.map((step) => (
            <StepCard 
              key={step.stepNumber}
              stepNumber={step.stepNumber}
              title={step.title}
              description={step.description}
            />
          ))}
        </div>

        {/* Scenarios Section */}
        <div className="scenarios-section">
          {/* Horizontal Divider */}
          <div className="scenarios-divider"></div>
          <h2 className="scenarios-heading">{dataprepData.scenarios.heading}</h2>
          
          <div className="scenarios-grid">
            {dataprepData.scenarios.cards.map((scenario, index) => (
              <ScenarioCard 
                key={index}
                icon={getIconPath(scenario.icon)}
                title={scenario.title}
                description={scenario.description}
              />
            ))}
          </div>
        </div>

        {/* Bottom Call to Action */}
        <div className="bottom-cta">
          <div className="cta-content">
          <img src={getIconPath('Lightbulb.svg')} alt="light bulb" className="" width="24" height="24" />
            <span className="cta-text">{dataprepData.callToAction.text}</span>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.33334 8H12.6667M12.6667 8L8.00001 3.33333M12.6667 8L8.00001 12.6667" stroke="#FFA500" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataprepGettingStarted;
